import { Vec } from "@tldraw/editor";
import {
  distances,
  ingest,
  inputX,
  inputY,
  inputZ,
  pointCount,
  pointX,
  pointY,
  pressures,
  runningLengths
} from "./core.mjs";
function getStrokePoints(rawInputPoints, options = {}) {
  ingest(rawInputPoints, options);
  const n = pointCount;
  const ptX = pointX;
  const ptY = pointY;
  const inX = inputX;
  const inY = inputY;
  const inZ = inputZ;
  const press = pressures;
  const dists = distances;
  const runs = runningLengths;
  const strokePoints = new Array(n);
  for (let i = 0; i < n; i++) {
    const input = new Vec(inX[i], inY[i], inZ[i]);
    const point = i === 0 ? input : new Vec(ptX[i], ptY[i], inZ[i]);
    strokePoints[i] = {
      point,
      input,
      pressure: press[i],
      distance: dists[i],
      runningLength: runs[i],
      radius: 1
    };
  }
  return strokePoints;
}
export {
  getStrokePoints
};
//# sourceMappingURL=getStrokePoints.mjs.map
